import { Chain } from 'wagmi/chains';
import { ARB, BNB, ChainId, DAN, DANNY, ETHER, JSBI, Percent, POLYGON, Token } from '@pancakeswap/sdk'
import { parseUnits } from '@ethersproject/units'
import { BigNumber } from '@ethersproject/bignumber'
import { MAIN_TOKEN2, BUSD, MAIN_TOKEN3, MAIN_TOKEN, MAIN_TOKEN4, USDT, WBNB, USDW, CUSTOM_STABLE_COINS } from './tokens'
import { ChainTokenList } from './types'
import { Web3Provider } from '@ethersproject/providers'
import { getRouterContract } from 'utils/exchange'
import { zeroAddress } from 'viem'


export const ROUTER_ADDRESS = {
  [ChainId.BSC]: '0x6cce231a88dc1f0c5ce53151486759a84530a297',
  // [ChainId.ETH]: '0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D',
  // [ChainId.BASE]: '0xef8cb60aceb32823755a11b79d608579b5093aa0',
  // [ChainId.POLYGON]: '0x61ce4A8D599201C3a01217962Ccffd0A8a0f23A2',
  // [ChainId.ARB]: '0xd0f39D969b11f1f98e328055871F7A894337FeEe',
  [ChainId.BSC_TESTNET]: '0xb3a27a56090838A0860548f097f5C53ac393f876',
  // [ChainId.BASE_SEPOLIA]: '0x6682375ebC1dF04676c0c5050934272368e6e883',
  // [ChainId.DAN]: '0x977F314B82267a2284e945f1De4b68667C3b1262',
  // [ChainId.DANNY]: '0x708E8574D232E57f6593734b4110EFEE2a079CdF',
}

// used to construct intermediary pairs for trading
export const BASES_TO_CHECK_TRADES_AGAINST: ChainTokenList = {
  [ChainId.BSC]: [ USDW[ChainId.BSC], USDT[ChainId.BSC]],
  [ChainId.BSC_TESTNET]: [USDW[ChainId.BSC_TESTNET], USDT[ChainId.BSC_TESTNET]]
}


/**
 * Additional bases for specific tokens
 * @example { [WBTC.address]: [renBTC], [renBTC.address]: [WBTC] }
 */
export const ADDITIONAL_BASES: { [chainId in ChainId]?: { [tokenAddress: string]: Token[] } } = {
  [ChainId.BSC]: {},
  [ChainId.BSC_TESTNET]: {}
}

/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 * @example [AMPL.address]: [DAI, WNATIVE[ChainId.BSC]]
 */
export const CUSTOM_BASES: { [chainId in ChainId]?: { [tokenAddress: string]: Token[] } } = {
  [ChainId.BSC]: {},
}

// used for display in the default list when adding liquidity
export const SUGGESTED_BASES: ChainTokenList = {
  [ChainId.BSC]: [MAIN_TOKEN[ChainId.BSC], USDT[ChainId.BSC], WBNB[ChainId.BSC]],
  // [ChainId.ETH]: [MAIN_TOKEN[ChainId.ETH], USDT[ChainId.ETH], WBNB[ChainId.ETH], MAIN_TOKEN2[ChainId.ETH], MAIN_TOKEN3[ChainId.ETH], MAIN_TOKEN4[ChainId.ETH]],
  // [ChainId.ARB]: [MAIN_TOKEN[ChainId.ARB], USDT[ChainId.ARB], WBNB[ChainId.ARB], MAIN_TOKEN2[ChainId.ARB], MAIN_TOKEN3[ChainId.ARB], MAIN_TOKEN4[ChainId.ARB]],
  // [ChainId.BASE]: [MAIN_TOKEN[ChainId.BASE], USDW[ChainId.BASE], USDT[ChainId.BASE], BUSD[ChainId.BASE], WBNB[ChainId.BASE], MAIN_TOKEN2[ChainId.BASE], MAIN_TOKEN3[ChainId.BASE], MAIN_TOKEN4[ChainId.BASE]],
  // [ChainId.POLYGON]: [MAIN_TOKEN[ChainId.POLYGON], USDW[ChainId.POLYGON], USDT[ChainId.POLYGON], BUSD[ChainId.POLYGON], WBNB[ChainId.POLYGON], MAIN_TOKEN2[ChainId.POLYGON], MAIN_TOKEN3[ChainId.POLYGON], MAIN_TOKEN4[ChainId.POLYGON]],
  // [ChainId.BASE_SEPOLIA]: [MAIN_TOKEN[ChainId.BASE_SEPOLIA], USDW[ChainId.BASE_SEPOLIA], USDT[ChainId.BASE_SEPOLIA], BUSD[ChainId.BASE_SEPOLIA], WBNB[ChainId.BASE_SEPOLIA], MAIN_TOKEN2[ChainId.BASE_SEPOLIA], MAIN_TOKEN3[ChainId.BASE_SEPOLIA], MAIN_TOKEN4[ChainId.BASE_SEPOLIA]],
  [ChainId.BSC_TESTNET]: [MAIN_TOKEN[ChainId.BSC_TESTNET], USDT[ChainId.BSC_TESTNET], WBNB[ChainId.BSC_TESTNET]],
  // [ChainId.DAN]: [MAIN_TOKEN[ChainId.DAN], USDT[ChainId.DAN], WBNB[ChainId.DAN], MAIN_TOKEN2[ChainId.DAN], MAIN_TOKEN3[ChainId.DAN], MAIN_TOKEN4[ChainId.DAN]],
  // [ChainId.DANNY]: [MAIN_TOKEN[ChainId.DANNY], USDT[ChainId.DANNY], WBNB[ChainId.DANNY], MAIN_TOKEN2[ChainId.DANNY], MAIN_TOKEN3[ChainId.DANNY], MAIN_TOKEN4[ChainId.DANNY]],
}

// used to construct the list of all pairs we consider by default in the frontend
export const BASES_TO_TRACK_LIQUIDITY_FOR: ChainTokenList = {
  [ChainId.BSC]: [MAIN_TOKEN[ChainId.BSC], USDT[ChainId.BSC], WBNB[ChainId.BSC]],
  // [ChainId.ETH]: [MAIN_TOKEN[ChainId.ETH], USDW[ChainId.ETH], USDT[ChainId.ETH], BUSD[ChainId.ETH], WBNB[ChainId.ETH], MAIN_TOKEN2[ChainId.ETH], MAIN_TOKEN3[ChainId.ETH], MAIN_TOKEN4[ChainId.ETH]],
  // [ChainId.ARB]: [MAIN_TOKEN[ChainId.ARB], USDW[ChainId.ARB], USDT[ChainId.ARB], BUSD[ChainId.ARB], WBNB[ChainId.ARB], MAIN_TOKEN2[ChainId.ARB], MAIN_TOKEN3[ChainId.ARB], MAIN_TOKEN4[ChainId.ARB]],
  // [ChainId.BASE]: [MAIN_TOKEN[ChainId.BASE], USDW[ChainId.BASE], USDT[ChainId.BASE], BUSD[ChainId.BASE], WBNB[ChainId.BASE], MAIN_TOKEN2[ChainId.BASE], MAIN_TOKEN3[ChainId.BASE], MAIN_TOKEN4[ChainId.BASE]],
  // [ChainId.POLYGON]: [MAIN_TOKEN[ChainId.POLYGON], USDW[ChainId.POLYGON], USDT[ChainId.POLYGON], BUSD[ChainId.POLYGON], WBNB[ChainId.POLYGON], MAIN_TOKEN2[ChainId.POLYGON], MAIN_TOKEN3[ChainId.POLYGON], MAIN_TOKEN4[ChainId.POLYGON]],
  [ChainId.BSC_TESTNET]: [MAIN_TOKEN[ChainId.BSC_TESTNET], USDT[ChainId.BSC_TESTNET], WBNB[ChainId.BSC_TESTNET]],
  // [ChainId.BASE_SEPOLIA]: [MAIN_TOKEN[ChainId.BASE_SEPOLIA], USDW[ChainId.BASE_SEPOLIA], USDT[ChainId.BASE_SEPOLIA], BUSD[ChainId.BASE_SEPOLIA], WBNB[ChainId.BASE_SEPOLIA], MAIN_TOKEN2[ChainId.BASE_SEPOLIA], MAIN_TOKEN3[ChainId.BASE_SEPOLIA], MAIN_TOKEN4[ChainId.BASE_SEPOLIA]],
  // [ChainId.DAN]: [MAIN_TOKEN[ChainId.DAN], USDW[ChainId.DAN], USDT[ChainId.DAN], BUSD[ChainId.DAN], WBNB[ChainId.DAN], MAIN_TOKEN2[ChainId.DAN], MAIN_TOKEN3[ChainId.DAN], MAIN_TOKEN4[ChainId.DAN]],
  // [ChainId.DANNY]: [MAIN_TOKEN[ChainId.DANNY], USDW[ChainId.DANNY], USDT[ChainId.DANNY], BUSD[ChainId.DANNY], WBNB[ChainId.DANNY], MAIN_TOKEN2[ChainId.DANNY], MAIN_TOKEN3[ChainId.DANNY], MAIN_TOKEN4[ChainId.DANNY]],
}

export const PINNED_PAIRS: { readonly [chainId in ChainId]?: [Token, Token][] } = {
  [ChainId.BSC]: [
    [MAIN_TOKEN[ChainId.BSC], USDT[ChainId.BSC]],
    [USDT[ChainId.BSC], WBNB[ChainId.BSC]]

  ],
  [ChainId.BSC_TESTNET]: [
    [USDW[ChainId.BSC_TESTNET], USDT[ChainId.BSC_TESTNET]],
  ],
  // [ChainId.ETH]: [
  //   [USDT[ChainId.ETH], WBNB[ChainId.ETH]],
  //   [BUSD[ChainId.ETH], USDT[ChainId.ETH]],
  //   [USDT[ChainId.ETH], MAIN_TOKEN2[ChainId.ETH]],
  //   [WBNB[ChainId.ETH], MAIN_TOKEN3[ChainId.ETH]],
  //   [WBNB[ChainId.ETH], MAIN_TOKEN4[ChainId.ETH]],
  //   [MAIN_TOKEN2[ChainId.ETH], WBNB[ChainId.ETH]],
  //   [MAIN_TOKEN3[ChainId.ETH], WBNB[ChainId.ETH]],
  //   [MAIN_TOKEN3[ChainId.ETH], MAIN_TOKEN4[ChainId.ETH]],
  // ],
  // [ChainId.BASE]: [
  //   [USDT[ChainId.BASE], WBNB[ChainId.BASE]],
  //   [BUSD[ChainId.BASE], USDT[ChainId.BASE]],
  //   [USDT[ChainId.BASE], MAIN_TOKEN2[ChainId.BASE]],
  //   [WBNB[ChainId.BASE], MAIN_TOKEN3[ChainId.BASE]],
  //   [WBNB[ChainId.BASE], MAIN_TOKEN4[ChainId.BASE]],
  //   [MAIN_TOKEN2[ChainId.BASE], WBNB[ChainId.BASE]],
  //   [MAIN_TOKEN3[ChainId.BASE], WBNB[ChainId.BASE]],
  //   [MAIN_TOKEN3[ChainId.BASE], MAIN_TOKEN4[ChainId.BASE]],
  // ],
  // [ChainId.BASE_SEPOLIA]: [
  //   [USDW[ChainId.BASE_SEPOLIA], USDT[ChainId.BASE_SEPOLIA]],
  // ],
  // [ChainId.POLYGON]: [
  //   [USDT[ChainId.POLYGON], WBNB[ChainId.POLYGON]],
  //   [BUSD[ChainId.POLYGON], USDT[ChainId.POLYGON]],
  //   [USDT[ChainId.POLYGON], MAIN_TOKEN2[ChainId.POLYGON]],
  //   [WBNB[ChainId.POLYGON], MAIN_TOKEN3[ChainId.POLYGON]],
  //   [WBNB[ChainId.POLYGON], MAIN_TOKEN4[ChainId.POLYGON]],
  //   [MAIN_TOKEN2[ChainId.POLYGON], WBNB[ChainId.POLYGON]],
  //   [MAIN_TOKEN3[ChainId.POLYGON], WBNB[ChainId.POLYGON]],
  //   [MAIN_TOKEN3[ChainId.POLYGON], MAIN_TOKEN4[ChainId.POLYGON]],
  // ],
  // [ChainId.ARB]: [
  //   [USDT[ChainId.ARB], WBNB[ChainId.ARB]],
  //   [BUSD[ChainId.ARB], USDT[ChainId.ARB]],
  //   [USDT[ChainId.ARB], MAIN_TOKEN2[ChainId.ARB]],
  //   [WBNB[ChainId.ARB], MAIN_TOKEN3[ChainId.ARB]],
  //   [WBNB[ChainId.ARB], MAIN_TOKEN4[ChainId.ARB]],
  //   [MAIN_TOKEN2[ChainId.ARB], WBNB[ChainId.ARB]],
  //   [MAIN_TOKEN3[ChainId.ARB], WBNB[ChainId.ARB]],
  //   [MAIN_TOKEN3[ChainId.ARB], MAIN_TOKEN4[ChainId.ARB]],
  // ],
  // [ChainId.DAN]: [
  //   [USDT[ChainId.DAN], WBNB[ChainId.DAN]],
  //   [BUSD[ChainId.DAN], USDT[ChainId.DAN]],
  //   [USDT[ChainId.DAN], MAIN_TOKEN2[ChainId.DAN]],
  //   [WBNB[ChainId.DAN], MAIN_TOKEN3[ChainId.DAN]],
  //   [WBNB[ChainId.DAN], MAIN_TOKEN4[ChainId.DAN]],
  //   [MAIN_TOKEN2[ChainId.DAN], WBNB[ChainId.DAN]],
  //   [MAIN_TOKEN3[ChainId.DAN], WBNB[ChainId.DAN]],
  //   [MAIN_TOKEN3[ChainId.DAN], MAIN_TOKEN4[ChainId.DAN]],
  // ],
  // [ChainId.DANNY]: [
  //   [USDT[ChainId.DANNY], WBNB[ChainId.DANNY]],
  //   [BUSD[ChainId.DANNY], USDT[ChainId.DANNY]],
  //   [USDT[ChainId.DANNY], MAIN_TOKEN2[ChainId.DANNY]],
  //   [WBNB[ChainId.DANNY], MAIN_TOKEN3[ChainId.DANNY]],
  //   [WBNB[ChainId.DANNY], MAIN_TOKEN4[ChainId.DANNY]],
  //   [MAIN_TOKEN2[ChainId.DANNY], WBNB[ChainId.DANNY]],
  //   [MAIN_TOKEN3[ChainId.DANNY], WBNB[ChainId.DANNY]],
  //   [MAIN_TOKEN3[ChainId.DANNY], MAIN_TOKEN4[ChainId.DANNY]],
  // ],
}

export const BIG_INT_ZERO = JSBI.BigInt(0)
export const BIG_INT_TEN = JSBI.BigInt(0)

// one basis point
export const BIPS_BASE = JSBI.BigInt(10000)
export const ONE_BIPS = new Percent(JSBI.BigInt(1), BIPS_BASE)
// used for warning states
export const ALLOWED_PRICE_IMPACT_LOW: Percent = new Percent(JSBI.BigInt(100), BIPS_BASE) // 1%
export const ALLOWED_PRICE_IMPACT_MEDIUM: Percent = new Percent(JSBI.BigInt(300), BIPS_BASE) // 3%
export const ALLOWED_PRICE_IMPACT_HIGH: Percent = new Percent(JSBI.BigInt(500), BIPS_BASE) // 5%
// if the price slippage exceeds this number, force the user to type 'confirm' to execute
export const PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN: Percent = new Percent(JSBI.BigInt(1000), BIPS_BASE) // 10%
// for non expert mode disable swaps above this
export const BLOCKED_PRICE_IMPACT_NON_EXPERT: Percent = new Percent(JSBI.BigInt(1500), BIPS_BASE) // 15%

// used to ensure the user doesn't send so much ETH so they end up with <.01
export const MIN_BNB: JSBI = JSBI.exponentiate(BIG_INT_TEN, JSBI.BigInt(16)) // .01 ETH
export const BETTER_TRADE_LESS_HOPS_THRESHOLD = new Percent(JSBI.BigInt(50), BIPS_BASE)

export const ZERO_PERCENT = new Percent('0')
export const ONE_HUNDRED_PERCENT = new Percent('1')

export const BASE_FEE = new Percent(JSBI.BigInt(25), BIPS_BASE)
export const INPUT_FRACTION_AFTER_FEE = ONE_HUNDRED_PERCENT.subtract(BASE_FEE)

// BNB
export const DEFAULT_INPUT_CURRENCY = {
  [ChainId.BSC]: USDT[ChainId.BSC].address,
  [ChainId.BSC_TESTNET]: USDT[ChainId.BSC_TESTNET].address,
  // [ChainId.ETH]: USDT[ChainId.ETH].address,
  // [ChainId.ARB]: USDT[ChainId.ARB].address,
  // [ChainId.BASE]: USDT[ChainId.BASE].address,
  // [ChainId.BASE_SEPOLIA]: USDT[ChainId.BASE_SEPOLIA].address,
  // [ChainId.POLYGON]: USDT[ChainId.POLYGON].address,
  // [ChainId.DAN]: USDT[ChainId.DAN].address,
  // [ChainId.DANNY]: USDT[ChainId.DANNY].address,
}

export const DEFAULT_OUTPUT_CURRENCY = {
  [ChainId.BSC]: MAIN_TOKEN[ChainId.BSC].address,
  [ChainId.BSC_TESTNET]: USDW[ChainId.BSC_TESTNET].address,
  // [ChainId.ETH]: MAIN_TOKEN[ChainId.ETH].address,
  // [ChainId.ARB]: MAIN_TOKEN[ChainId.ARB].address,
  // [ChainId.BASE]: MAIN_TOKEN[ChainId.BASE].address,
  // [ChainId.BASE_SEPOLIA]: MAIN_TOKEN[ChainId.BASE_SEPOLIA].address,
  // [ChainId.POLYGON]: MAIN_TOKEN[ChainId.POLYGON].address,
  // [ChainId.DAN]: "ETH",
  // [ChainId.DANNY]: "ETH",
}

export const NATIVE_CURRENCY_MAP = {
  [ChainId.BSC]: BNB,
  // [ChainId.ETH]: ETHER,
  // [ChainId.ARB]: ARB,
  // [ChainId.BASE]: ETHER,
  // [ChainId.POLYGON]: POLYGON,
  // [ChainId.BASE_SEPOLIA]: ETHER,
  [ChainId.BSC_TESTNET]: BNB,
  // [ChainId.DAN]: DAN,
  // [ChainId.DANNY]: DANNY,
}
// CAKE


// Handler string is passed to Gelato to use PCS router
export const GELATO_HANDLER = 'pancakeswap'
export const GENERIC_GAS_LIMIT_ORDER_EXECUTION = BigNumber.from(500000)

export const LIMIT_ORDERS_DOCS_URL = 'https://docs.punkswap.exchange/products/pancakeswap-exchange/limit-orders'
export const SUPPORT_CHAINS = [ChainId.BSC, ChainId.BSC_TESTNET]
export const DEFAULT_CHAIN = 56;

export const bsc: any = {
  id: 56,
  name: 'Binanace',
  network: 'bsc',
  rpcUrls: {
    default: 'https://bsc-dataseed1.bnbchain.org',
    public: 'https://bsc-dataseed1.bnbchain.org',
  },
  blockExplorers: {
    default: { name: 'BaseScan', url: 'https://bscscan.com/' },
  },
  multicall: {
    address: '0xcf591ce5574258ac4550d96c545e4f3fd49a74ec',
    blockCreated: 7162653,
  },
  nativeCurrency: {
    name: 'BNB',
    symbol: 'BNB',
    decimals: 18,
  },
}

export const bscTest: any = {
  id: 97,
  name: 'Testnet',
  network: 'bscTesnet',
  nativeCurrency: {
    decimals: 18,
    name: 'BNB',
    symbol: 'BNB',
  },
  rpcUrls: {
    default: 'https://bsc-testnet-rpc.publicnode.com',
    public: 'https://bsc-testnet-rpc.publicnode.com',
  },
  blockExplorers: {
    default: { name: 'BaseScan', url: 'https://testnet.bscscan.com/' },
  },
  multicall: {
    address: '0xa54fe4a3dbd1eb21524cd73754666b7e13b4cb18',
    blockCreated: 9495869,
  },
  testnet: true,
}

export const mainnet: any = {
  id: 1,
  name: 'Ethereum',
  network: 'ethereum',
  rpcUrls: {
    default: 'https://ethereum-rpc.publicnode.com',
    public: 'https://ethereum-rpc.publicnode.com',
  },
  blockExplorers: {
    default: { name: 'EtherScan', url: 'https://etherscan.io/' },
  },
  multicall: {
    address: '0x5BA1e12693Dc8F9c48aAD8770482f4739bEeD696',
    blockCreated: 12336033,
  },
  nativeCurrency: {
    name: 'ETH',
    symbol: 'ETH',
    decimals: 18,
  },
}

export const base: any = {
  id: 8453,
  name: 'Base',
  network: 'base',
  rpcUrls: {
    default: 'https://mainnet.base.org',
    public: 'https://mainnet.base.org',
  },
  blockExplorers: {
    default: { name: 'BaseScan', url: 'https://basescan.org/' },
  },
  multicall: {
    address: '0xfEE958Fa595B4478cea7560C91400A98b83d6C91',
    blockCreated: 21524736,
  },
  nativeCurrency: {
    name: 'ETH',
    symbol: 'ETH',
    decimals: 18,
  },
}

export const base_sepolia: any = {
  id: 84532,
  name: 'Base Sepolia',
  network: 'base_sepolia',
  rpcUrls: {
    default: 'https://sepolia.base.org',
    public: 'https://sepolia.base.org',
  },
  blockExplorers: {
    default: { name: 'BaseScan', url: 'https://sepolia.basescan.org/' },
  },
  multicall: {
    address: '0x46751862B49E6273f9669216A3072b77a3178b65',
    blockCreated: 9428799,
  },
  nativeCurrency: {
    name: 'ETH',
    symbol: 'ETH',
    decimals: 18,
  },
}

export const polygon: any = {
  id: 137,
  name: 'Polygon',
  network: 'polygon',
  rpcUrls: {
    default: 'https://polygon-rpc.com',
    public: 'https://polygon-rpc.com',
  },
  blockExplorers: {
    default: { name: 'BaseScan', url: 'https://polygonscan.com/' },
  },
  multicall: {
    address: '0xed386Fe855C1EFf2f843B910923Dd8846E45C5A4',
    blockCreated: 27619819,
  },
  nativeCurrency: {
    name: 'Polygon',
    symbol: 'POL',
    decimals: 18,
  },
}

export const optimism_mainnet: any = {
  id: 42161,
  name: 'Arbitrum One',
  network: 'arbitrum',
  rpcUrls: {
    default: 'https://arb1.arbitrum.io/rpc',
    public: 'https://arb1.arbitrum.io/rpc',
  },
  blockExplorers: {
    default: { name: 'ArbiScan', url: 'https://arbiscan.io/' },
  },
  multicall: {
    address: '0xBF69a56D35B8d6f5A8e0e96B245a72F735751e54',
    blockCreated: 122718597,
  },
  nativeCurrency: {
    name: 'ETH',
    symbol: 'ETH',
    decimals: 18,
  },
}

export const danchain = {
  id: 69,
  name: 'DAN Chain',
  network: 'danmainnet',
  nativeCurrency: {
    decimals: 18,
    name: 'DAN',
    symbol: 'DAN',
  },
  rpcUrls: {
    default: 'https://mainnet.danscan.io',
    public: 'https://mainnet.danscan.io',
  },
  blockExplorers: {
    default: { name: 'BaseScan', url: 'https://danscan.io/' },
  },
  multicall: {
    address: '0x4d76592D83585Cf00792057749B03f97964668E8',
    blockCreated: 97265,
  }
}


export const dannychain = {
  id: 5069,
  name: 'Danny',
  network: 'dannymainnet',
  nativeCurrency: {
    decimals: 18,
    name: 'DAN',
    symbol: 'DAN',
  },
  rpcUrls: {
    default: 'https://rpc.dannyscan.com',
    public: 'https://rpc.dannyscan.com',
  },
  blockExplorers: {
    default: { name: 'DannyScan', url: 'https://dannyscan.com' },
  },
  multicall: {
    address: '0x762860BbBc43eb1C611076f18668d7ce6b23D4E6',
    blockCreated: 43840,
  }
}

export const rpc_urls = {
  [ChainId.BSC]: "https://bsc-dataseed1.bnbchain.org",
  // [ChainId.ETH]: "https://ethereum-rpc.publicnode.com",
  // [ChainId.ARB]: "https://arb1.arbitrum.io/rpc",
  // [ChainId.BASE]: "https://mainnet.base.org",
  // [ChainId.POLYGON]: "https://polygon-rpc.com",
  [ChainId.BSC_TESTNET]: "https://bsc-testnet-rpc.publicnode.com",
  // [ChainId.BASE_SEPOLIA]: "https://sepolia.base.org",
  // [ChainId.DAN]: "https://mainnet.danscan.io",
  // [ChainId.DANNY]: "https://rpc.dannyscan.com",
}

export const chains = [bsc, bscTest]


export const trimAddress = (addr) => {
  return `${addr.substring(0, 6)}...${addr.substring(addr.length - 4)}`;
}

export const getChainId = (chain, isPure = false) => {
  if (!isPure && chain && chain.id && SUPPORT_CHAINS.includes(chain.id)) {
    return chain.id;
  }

  if (isPure && chain && SUPPORT_CHAINS.includes(chain)) {
    return chain;
  }
  return DEFAULT_CHAIN;
};

export const getCurrentEther = (chain) => {
  let chainID = getChainId(chain);
  return NATIVE_CURRENCY_MAP[chainID];
}

export const GAS_PRICES = {
  [ChainId.BSC]: {
    "standard": parseUnits('1', 'gwei').toString(),
    "Fast": parseUnits('2', 'gwei').toString(),
    "Instant": parseUnits('4', 'gwei').toString()
  },
  [ChainId.BSC_TESTNET]: {
    "standard": parseUnits('1', 'gwei').toString(),
    "Fast": parseUnits('2', 'gwei').toString(),
    "Instant": parseUnits('4', 'gwei').toString()
  },
  // [ChainId.ETH]: {
  //   "standard": parseUnits('1', 'gwei').toString(),
  //   "Fast": parseUnits('5', 'gwei').toString(),
  //   "Instant": parseUnits('10', 'gwei').toString()
  // },
  // [ChainId.BASE]: {
  //   "standard": parseUnits('1', 'gwei').toString(),
  //   "Fast": parseUnits('2', 'gwei').toString(),
  //   "Instant": parseUnits('3', 'gwei').toString()
  // },
  // [ChainId.BASE_SEPOLIA]: {
  //   "standard": parseUnits('1', 'gwei').toString(),
  //   "Fast": parseUnits('2', 'gwei').toString(),
  //   "Instant": parseUnits('3', 'gwei').toString()
  // }
  // [ChainId.DAN]: {
  //   "standard": parseUnits('1', 'gwei').toString(),
  //   "Fast": parseUnits('2', 'gwei').toString(),
  //   "Instant": parseUnits('3', 'gwei').toString()
  // },
  // [ChainId.DANNY]: {
  //   "standard": parseUnits('4500', 'gwei').toString(),
  //   "Fast": parseUnits('4550', 'gwei').toString(),
  //   "Instant": parseUnits('4600', 'gwei').toString()
  // }
}


export const USDT_BNB_LP_ADDRESS = {
  [ChainId.BSC]: "0x16b9a82891338f9bA80E2D6970FddA79D1eb0daE",
  // [ChainId.ETH]: "0x0d4a11d5EEaaC28EC3F61d100daF4d40471f1852",
  // [ChainId.ARB]: "0x0d4a11d5EEaaC28EC3F61d100daF4d40471f1852",
  // [ChainId.BASE]: "0x88A43bbDF9D098eEC7bCEda4e2494615dfD9bB9C",
  // [ChainId.POLYGON]: "0x711B6f6788E4cB0f7034bF02b149118A46e500c2",
  [ChainId.BSC_TESTNET]: "0xf76723df860610611b2df4ad7787ad476e12e2c2",
  // [ChainId.BASE_SEPOLIA]: "0x96761064c709E6c6EB61268fcc7e830C71911755",
  // [ChainId.DAN]: "0x96761064c709E6c6EB61268fcc7e830C71911755",
  // [ChainId.DANNY]: "0x96761064c709E6c6EB61268fcc7e830C71911755",
}

export const MAIN_TOKEN_LP_ADDRESS = {
  [ChainId.BSC]: "0x057fD64AC71A313f9242D2F8CC6D2F299adBeb63",
  [ChainId.BSC_TESTNET]: "0xf76723df860610611b2df4ad7787ad476e12e2c2"
}

export const TOTAL_SUPPLY = 499990000;

export const isStableCoin = (token: any, chainId: number): boolean => {
  if (!CUSTOM_STABLE_COINS) return false
  return CUSTOM_STABLE_COINS.some(
    (stableCoin) =>
      stableCoin[chainId]?.address?.toLowerCase() === token?.address?.toLowerCase(),
  )
}


export const formatSymbol = (symbol?: string, chainId: any = DEFAULT_CHAIN) => {
  if (!symbol) return ''
  if (symbol === 'ETH') {
    return NATIVE_CURRENCY_MAP[chainId]?.symbol ?? symbol
  }
  return symbol
}

export const CHAIN_IMAGES = {
  [ChainId.BSC]: '/thbm/images/tokens/bsc.png',
  // [ChainId.ETH]: '/thbm/images/tokens/eth.png',
  // [ChainId.BASE]: '/thbm/images/tokens/base.webp',
  // [ChainId.ARB]: '/thbm/images/tokens/arb.png',
  // [ChainId.POLYGON]: '/thbm/images/tokens/polygon.svg',
  [ChainId.BSC_TESTNET]: '/thbm/images/tokens/bsc.png',
  // [ChainId.BASE_SEPOLIA]: '/thbm/images/tokens/base.webp',
  // [ChainId.DAN]: '/thbm/images/tokens/dan.png',
  // [ChainId.DANNY]: '/thbm/images/tokens/danny.png',
}

export const formatPrice = (num, decimals = 8) => {
  if (!num) return 0;
  return new Intl.NumberFormat('en-US', { maximumSignificantDigits: decimals }).format(num);

}

export const cakePriceLinks = {
  [ChainId.BSC]: `/swap?outputCurrency=${MAIN_TOKEN[ChainId.BSC].address}`,
  // [ChainId.ETH]: `/swap?outputCurrency=${MAIN_TOKEN[ChainId.ETH].address}`,
  // [ChainId.BASE]: `/swap?outputCurrency=${MAIN_TOKEN[ChainId.BASE].address}`,
  // [ChainId.POLYGON]: `/swap?outputCurrency=${MAIN_TOKEN[ChainId.POLYGON].address}`,
  // [ChainId.DAN]: `/swap?outputCurrency=${MAIN_TOKEN[ChainId.DAN].address}`,
  // [ChainId.DANNY]: `/swap?outputCurrency=${MAIN_TOKEN[ChainId.DAN].address}`,
  default: `/swap?outputCurrency=${MAIN_TOKEN[ChainId.BSC].address}`
}




export const customTokenList = {
  [ChainId.BSC] : [USDT[ChainId.BSC],USDW[ChainId.BSC],WBNB[ChainId.BSC]],
  [ChainId.BSC_TESTNET] : [USDT[ChainId.BSC_TESTNET],USDW[ChainId.BSC_TESTNET],WBNB[ChainId.BSC_TESTNET]],
}